import { Invitation, ProfileGetAliasesResponsePayload, LobbyPlayer } from '@playcastdotio/Messaging';
import { makeStateStore } from '@playcastdotio/StateStore';
import { ProfileState } from '@playcastdotio/SharedComponents';
import { IdentityPlatform, InvitationSendState } from '@playcastdotio/CoreTypes';

export const joinIdState = makeStateStore<string>('');

const initialRuleState = {
  requireAuthOnDeck: false,
  autoJoinFromQueue: true,
};
export const ruleState = makeStateStore(initialRuleState);

export const profileState = makeStateStore<ProfileState>({
  invitations: [],
  profile: null,
  isLoading: true,
  error: null,
  creating: false,
  isOwner: false,
});

const initialMatchmakeToPublicMachineState = (() => {
  try {
    return localStorage.getItem('matchmakeToPublicMachine') === 'true' || false;
  } catch {
    return false;
  }
})();

export const matchmakeToPublicMachineState = makeStateStore({ matchmakeToPublicMachine: initialMatchmakeToPublicMachineState });

// Add persistence listener for matchmakeToPublicMachine
matchmakeToPublicMachineState.addListener((state) => {
  try {
    localStorage.setItem('matchmakeToPublicMachine', state.matchmakeToPublicMachine.toString());
  } catch (error) {
    console.warn('[lobbyStores] Failed to persist matchmakeToPublicMachine:', error);
  }
});

export const ownerAliasState = makeStateStore<ProfileGetAliasesResponsePayload>({
  success: false,
  aliases: {
    default: '',
  },
  usernames: {},
});

const initialDeckState: {
  invitations: Invitation[];
  name: string;
  greeting: string;
} = {
  invitations: [],
  name: '',
  greeting: '',
};
export const deckState = makeStateStore(initialDeckState);

type InvitationState = {
  success: boolean;
  selectedInvite: Invitation | undefined;
  invitationPlayerId: string;
  isAlias: boolean;
  invites: { [inviteId: string]: Invitation | false };
  defaultAlias?: string;
  defaultAliasPlatform?: IdentityPlatform;
};
export const invitationState = makeStateStore<InvitationState>({
  success: true,
  isAlias: false,
  invites: {},
  invitationPlayerId: '',
  selectedInvite: undefined,
  defaultAlias: undefined,
  defaultAliasPlatform: undefined,
});

const initialLobbyState = {
  position: 0,
  accepted: false,
  rejected: false,
  broadcastHostId: '',
  lobbyPlayerId: '',
};
export const lobbyState = makeStateStore(initialLobbyState);

const initialPlayerNameState: { name: string } = (() => {
  try {
    return { name: localStorage.getItem('name') || '' };
  } catch {
    return { name: '' };
  }
})();
export const playerNameState = makeStateStore<{ name: string }>(initialPlayerNameState);

export const invitationSendState = makeStateStore<InvitationSendState>({
  emailCount: 0,
  emailLimit: 0,
  reachedEmailInviteLimit: false,
  emailLimitExpiry: 0,
  smsCount: 0,
  smsLimit: 0,
  reachedSmsInviteLimit: false,
  smsLimitExpiry: 0,
});

// State store for lobby query responses
type LobbyQueryState = {
  [invitationId: string]: {
    players: LobbyPlayer[];
    lastUpdated: number;
    connectedPlayerCount: number;
  };
};

export const lobbyQueryState = makeStateStore<LobbyQueryState>({});
